import { useState } from 'react'
import TmdbFooter from './TmdbFooter'
import DailyCard from './DailyCard'
import { IconDice, IconScroll, IconTicket, IconChevronRight, IconX, IconPlay } from './icons'

export default function SinglePlayer({ tickets, onDailyChallenge, dailyCompleted, onViewFilmStrip, onStart, onOpenStore, onHistoricalPuzzles, onBack }) {
  const [confirmOpen, setConfirmOpen] = useState(false)
  const canAfford = tickets >= 1

  const handleStartClick = () => {
    if (!canAfford) { onOpenStore(); return }
    setConfirmOpen(true)
  }

  const handleStartKey = (e) => {
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleStartClick() }
  }

  return (
    <div className="mp-screen">
      <div className="screen-content">
        <div className="page-title">
          <h1 className="brand-logo">Play</h1>
          <div className="page-title__sub">Daily · Classic</div>
        </div>

        <div className="mp-modes mp-modes--vertical">
          {/* Daily Challenge — the shared home daily card, with the actor-details
              sub-card swapped for a "Play Past Puzzles" entry (same frame). */}
          <DailyCard
            onActivate={onDailyChallenge}
            bottom={
              <>
                <div className="home__daily-divider" aria-hidden="true" />
                <div
                  className="home__daily-spotlight daily-card__past"
                  role="button"
                  tabIndex={0}
                  onClick={(e) => { e.stopPropagation(); onHistoricalPuzzles?.() }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); e.stopPropagation(); onHistoricalPuzzles?.() }
                  }}
                  aria-label="Play past puzzles"
                >
                  <div className="daily-card__past-icon" aria-hidden="true">
                    <IconScroll size={20} />
                  </div>
                  <div className="spotlight__info">
                    <p className="spotlight__name">Play Past Puzzles</p>
                  </div>
                  <span className="daily-card__past-chevron" aria-hidden="true">
                    <IconChevronRight size={18} />
                  </span>
                </div>
              </>
            }
          />

          <div
            className="play-card"
            role="button"
            tabIndex={0}
            onClick={handleStartClick}
            onKeyDown={handleStartKey}
            aria-label="Start a game — pick your own start and goal"
          >
            <div className="play-card__icon" aria-hidden="true">
              <IconDice size={22} />
            </div>
            <div className="play-card__title">Start a Game</div>
            <div className="play-card__subtitle">Pick your own start and goal</div>
            <div className="play-card__cta-row">
              <IconTicket size={13} aria-hidden="true" />
              <span>1 Ticket <span className="sep">·</span> Tap to begin</span>
              <IconChevronRight size={13} aria-hidden="true" />
            </div>
          </div>
        </div>

        <TmdbFooter />
      </div>

      {confirmOpen && (
        <div className="cue-card-confirm-overlay" onClick={() => setConfirmOpen(false)}>
          <div className="cue-card-confirm-dialog" onClick={(e) => e.stopPropagation()}>
            <p className="cue-card-confirm-dialog__title">Start a Game</p>
            <p className="cue-card-confirm-dialog__msg">
              Pick your own start and goal actors.
            </p>
            <p className="cue-card-confirm-dialog__cost">
              <IconTicket size={13} aria-hidden="true" />
              <span>1 Ticket · You have {tickets.toLocaleString()}</span>
            </p>
            <div className="confirm__actions">
              <button className="confirm__cancel" aria-label="Cancel" onClick={() => setConfirmOpen(false)}>
                <IconX size={20} />
              </button>
              <button className="confirm__confirm" aria-label="Confirm" onClick={() => { setConfirmOpen(false); onStart() }}>
                <IconPlay size={20} />
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
